import { Col, Row, Typography } from "antd";
import React from "react";
import Marquee from "react-fast-marquee";
import Partner1 from "../assets/images/logo1.jpg";
import Partner2 from "../assets/images/logo2.jpg";
import Partner3 from "../assets/images/logo3.jpg";
import Partner4 from "../assets/images/logo4.jpg";
import Partner5 from "../assets/images/logo5.jpg";
import Partner6 from "../assets/images/logo6.jpg";
import Partner7 from "../assets/images/logo7.jpg";
import Partner8 from "../assets/images/logo8.jpg";
import Partner9 from "../assets/images/logo9.jpg";
import Partner10 from "../assets/images/logo10.jpg";
import Partner11 from "../assets/images/logo11.jpg";
import Partner12 from "../assets/images/logo12.jpg";
import Partner13 from "../assets/images/logo13.jpg";
import Partner14 from "../assets/images/logo14.jpg";
import Partner15 from "../assets/images/logo15.jpg";
import Partner16 from "../assets/images/logo16.jpg";
import Partner17 from "../assets/images/logo17.jpg";
import Partner18 from "../assets/images/logo18.jpg";
import Partner19 from "../assets/images/logo19.jpg";
import Partner20 from "../assets/images/logo20.jpg";
import Partner21 from "../assets/images/logo21.jpg";
import Partner22 from "../assets/images/logo22.jpg";
import Partner23 from "../assets/images/logo23.jpg";
import Partner24 from "../assets/images/logo24.jpg";
import Partner25 from "../assets/images/logo25.jpg";
import Partner26 from "../assets/images/logo26.jpg";
import Partner27 from "../assets/images/logo27.jpg";
import "../components/partners.css";

const Partners = () => {
  const logos = [
    {
      src: Partner1,
      alt: "Partner 1",
    },
    {
      src: Partner2,
      alt: "Partner 2",
    },
    {
      src: Partner3,
      alt: "Partner 3",
    },
    {
      src: Partner4,
      alt: "Partner 4",
    },
    {
      src: Partner5,
      alt: "Partner 5",
    },
    {
      src: Partner6,
      alt: "Partner 6",
    },
    {
      src: Partner7,
      alt: "Partner 7",
    },
    {
      src: Partner8,
      alt: "Partner 8",
    },
    {
      src: Partner9,
      alt: "Partner 9",
    },
    {
      src: Partner10,
      alt: "Partner 10",
    },
    {
      src: Partner11,
      alt: "Partner 11",
    },
    {
      src: Partner12,
      alt: "Partner 12",
    },
    {
      src: Partner13,
      alt: "Partner 13",
    },
    {
      src: Partner14,
      alt: "Partner 14",
    },
    {
      src: Partner15,
      alt: "Partner 15",
    },
    {
      src: Partner16,
      alt: "Partner 16",
    },
    {
      src: Partner17,
      alt: "Partner 17",
    },
    {
      src: Partner18,
      alt: "Partner 18",
    },
    {
      src: Partner19,
      alt: "Partner 19",
    },
    {
      src: Partner20,
      alt: "Partner 20",
    },
    {
      src: Partner21,
      alt: "Partner 21",
    },
    {
      src: Partner22,
      alt: "Partner 22",
    },
    {
      src: Partner23,
      alt: "Partner 23",
    },
    {
      src: Partner24,
      alt: "Partner 24",
    },
    {
      src: Partner25,
      alt: "Partner 25",
    },
    {
      src: Partner26,
      alt: "Partner 26",
    },
    {
      src: Partner27,
      alt: "Partner 27",
    },
  ];
  return (
    <Row justify="center" style={{ paddingTop: 120 }}>
      <Col span={24}>
        <Row gutter={[0, 30]}>
          <Col span={24}>
            <Typography
              className="propertySearch"
              style={{ textAlign: "center" }}
            >
              Channel Partners
            </Typography>
          </Col>
          <Col style={{marginTop: 50}} span={24}>
            <div className="marqueeEdgeFade">
              <Marquee speed={50} pauseOnHover gradient={false} autoFill>
                {logos.map((logo, idx) => (
                  <img
                    key={idx}
                    src={logo.src}
                    alt={logo.alt}
                    style={{ height: 100, margin: "0 30px" }}
                  />
                ))}
              </Marquee>
            </div>
          </Col>
          <Col style={{marginTop: 50}} span={24}>
            <div className="marqueeEdgeFadeLeft">
              <Marquee speed={50} pauseOnHover gradient={false} autoFill direction="right">
                {logos.map((logo, idx) => (
                  <img
                    key={idx}
                    src={logo.src}
                    alt={logo.alt}
                    style={{ height: 100, margin: "0 30px" }}
                  />
                ))}
              </Marquee>
            </div>
          </Col>
        </Row>
      </Col>
    </Row>
  );
};

export default Partners;
